module.exports = __webpack_public_path__ + "static/media/c-high-protein.d5c30862.jpg";